import { ArrowRight } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { StepShell } from "./StepShell";
import { OptionGrid } from "./OptionGrid";

export const StepTiktok = ({ onNext, onBack }) => {
  const { state, update, meta } = useAdvisor();
  const toggle = (k) =>
    update({ tiktokGames: state.tiktokGames.includes(k) ? state.tiktokGames.filter((x) => x !== k) : [...state.tiktokGames, k] });

  return (
    <StepShell
      testid="advisor-step-tiktok" step={1} total={1} onBack={onBack}
      intro="Əla. Canlı yayımınızı daha interaktiv və gəlirli edə bilərik."
      title="Canlı yayımınız üçün nə istəyirsiniz?" subtitle="Bir neçə variant seçə bilərsiniz"
      footer={
        <button className="adv-btn w-full" disabled={!state.tiktokGames.length} onClick={onNext} data-testid="btn-tiktok-next">
          Canlı demonu göstər <ArrowRight className="h-5 w-5" />
        </button>
      }
    >
      <OptionGrid options={meta?.tiktok_games || []} value={state.tiktokGames} onToggle={toggle} prefix="tiktok-game" cols="grid-cols-2 sm:grid-cols-4" />
    </StepShell>
  );
};
